module.exports = {
  apiUrl: process.env.REACT_APP_API_URL,
  apiKey: process.env.REACT_APP_API_KEY_FREE_TO_FEED,
  tenant: 'free-to-feed',
  messageLimit: null,
  messageFlagEnabled: true,
  pageTitle: 'Ema - Free To Feed (Full)',
};
